import React from 'react'

export default function FloatingWhatsapp() {
  return (<>
      <a href=
      "https://wa.me/9779746672410" 
      targt="_blank"className="whatsapp-btn">
      <img
        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
        alt="WhatsApp"
        id="wtsappLogo"
      />
    </a>
    </>
    
  )
}
